export default __webpack_public_path__ + "static/media/customerUpdateRequest.3c3fc813.svg";